import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SUPPORT_EMAIL } from '#modules/utils/concierge';
import Spinner from '#components/Elements/Spinner/Spinner';
import { DialogBody, DialogFooter } from '#components/Elements/Dialog/Dialog';
import Button from '#components/Elements/Button/Button';
import PlatformLogo from '#components/Elements/PlatformLogo/PlatformLogo';
import styles from './Maintenance.scss';

export default function Maintenance() {
  // Refresh page every 10 seconds
  React.useEffect(() => {
    const interval = setInterval(() => {
      location.reload();
    }, 10000);
    return () => clearInterval(interval);
  }, []);
  return (
    <>
      <DialogBody>
        <div className={styles.content}>
          <div className={styles.banner}>
            <PlatformLogo width={160} height={160} />
          </div>
          <div className={styles.loadingTitle}>
            <FormattedMessage defaultMessage="Don't Panic!" />
          </div>
          <div className={styles.description}>
            <FormattedMessage defaultMessage="Please check your internet connection first." />
            <br />
            <FormattedMessage defaultMessage="If you are still seeing this message, we are most likely performing maintenance on our app." />{' '}
            <FormattedMessage defaultMessage=" Try again in a few minutes." />
            <br />
            <br />
            <FormattedMessage defaultMessage="Still having issues?" />{' '}
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Contact Us
            </a>
          </div>
          <div className={styles.loadingSpinner}>
            <Spinner />
          </div>
        </div>
      </DialogBody>
      <DialogFooter>
        <>
          <div />
          <Button
            onClick={() => {
              location.reload();
            }}
          >
            <FormattedMessage defaultMessage="Refresh Page" />
          </Button>
        </>
      </DialogFooter>
    </>
  );
}
